import React from 'react';
import { Route, Routes } from 'react-router-dom';
import './index.less';
import AuthenticatedApp from './layout/AuthenticatedApp';
import UnauthenticatedApp from './layout/UnauthenticatedApp';

const App: React.FC = () => {
  return (
    <Routes>
      <Route path="/login/*" element={<UnauthenticatedApp />} />
      <Route path="/*" element={<AuthenticatedApp />} />
    </Routes>
  );
};

export default App;
